import React from 'react';
import TagPreviewMainTabItem from '../../TagPreviewMainTabItem';
import './TagPreviewMainTabWrap.scss';

const TagPreviewMainTabWrap = (props) => {
  const { tagName, tagViewInfo, tagMainTab } = props;

  return (
    <div className="tag-preview-main-tab-wrap">
      {/* 태그 메인탭 아이탬 */}
      <TagPreviewMainTabItem tagName={tagName} tagViewInfo={tagViewInfo} itemContentList={tagMainTab.itemList} />
    </div>
  );
};

export default TagPreviewMainTabWrap;
